/**
 * Nero Signature Box Builder
 * Preserves all original cart/quantity logic; adds summary panel, slots, occasion, and glow.
 */

document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('ccb-wrapper');
  if (!wrapper) return;

  // ── State ────────────────────────────────────────────────────────────────
  var state = {
    selections: {},   // { "Name": { qty: N, weight: W } }
    fillOrder: [],    // [{ name, weight, image }, ...]  ordered chronologically for the tray
    totalPieces: 0,
    totalGrams: 0
  };

  var maxPieces    = parseInt(wrapper.dataset.maxPieces, 10)  || 28;
  var maxGrams     = parseInt(wrapper.dataset.maxGrams, 10)   || 1000;
  var isClassic    = wrapper.classList.contains('theme-classic');
  var baseVariantId = wrapper.dataset.baseVariantId;

  // ── DOM ──────────────────────────────────────────────────────────────────
  var cards          = document.querySelectorAll('.ccb-card');
  // Match both the qty-row +/− buttons AND the standalone "ADD" button.
  // All three carry data-action so a single selector covers them.
  var btnPlusList    = document.querySelectorAll('.ccb-card [data-action="plus"]');
  var btnMinusList   = document.querySelectorAll('.ccb-card [data-action="minus"]');
  var qtyInputs      = document.querySelectorAll('.ccb-qty-input');

  var piecesCountEl  = document.getElementById('ccb-pieces-count');
  var gramsCountEl   = document.getElementById('ccb-grams-count');
  var progressBar    = document.getElementById('ccb-progress-bar');
  var gramsBar       = document.getElementById('ccb-grams-bar');
  var summaryItems   = document.getElementById('ccb-summary-items');
  var summaryCta     = document.getElementById('ccb-summary-cta');

  var stickyFooter      = document.getElementById('ccb-sticky-footer');
  var footerPieces      = document.getElementById('ccb-footer-pieces');
  var footerGrams       = document.getElementById('ccb-footer-grams');
  var footerFill        = document.getElementById('ccb-footer-fill');
  var footerGramsFill   = document.getElementById('ccb-footer-grams-fill');
  var footerExpandBtn   = document.getElementById('ccb-footer-expand-btn');
  var addToCartBtn      = document.getElementById('ccb-add-to-cart');

  var upgradeModal      = document.getElementById('ccb-upgrade-modal');
  var closeModalBtns    = document.querySelectorAll('.js-close-modal');

  // Drawer
  var drawer            = document.getElementById('ccb-drawer');
  var drawerBackdrop    = document.getElementById('ccb-drawer-backdrop');
  var drawerClose       = document.getElementById('ccb-drawer-close');
  var drawerPieces      = document.getElementById('ccb-drawer-pieces');
  var drawerGrams       = document.getElementById('ccb-drawer-grams');
  var drawerPct         = document.getElementById('ccb-drawer-pct');
  var drawerBar         = document.getElementById('ccb-drawer-bar');
  var drawerGramsBar    = document.getElementById('ccb-drawer-grams-bar');
  var drawerItems       = document.getElementById('ccb-drawer-items');
  var drawerCta         = document.getElementById('ccb-drawer-cta');

  // Atelier: schematic tray + state-based progress phrase
  var trayEl            = document.getElementById('ccb-tray');
  var drawerTrayEl      = document.getElementById('ccb-drawer-tray');
  var traySlots         = trayEl ? Array.from(trayEl.querySelectorAll('.ccb-tray__slot')) : [];
  var drawerTraySlots   = drawerTrayEl ? Array.from(drawerTrayEl.querySelectorAll('.ccb-tray__slot')) : [];
  var phraseEl          = document.getElementById('ccb-summary-phrase');
  var drawerPhraseEl    = document.getElementById('ccb-drawer-phrase');

  // ── Update UI ────────────────────────────────────────────────────────────
  function updateUI() {
    state.totalPieces = 0;
    state.totalGrams  = 0;
    for (var k in state.selections) {
      state.totalPieces += state.selections[k].qty;
      state.totalGrams  += state.selections[k].qty * state.selections[k].weight;
    }

    var gramPct  = Math.min((state.totalGrams / maxGrams) * 100, 100);
    var gramPctRound  = Math.round(gramPct / 25) * 25;

    // Pieces display (informative counter)
    if (piecesCountEl) piecesCountEl.textContent = state.totalPieces;

    // Grams meter (right panel)
    if (gramsCountEl)  gramsCountEl.textContent = state.totalGrams;
    if (gramsBar)      {
      gramsBar.style.width = gramPct + '%';
      gramsBar.dataset.pct = gramPctRound;
    }

    // Sticky footer — pieces and grams
    if (footerPieces)     footerPieces.textContent  = state.totalPieces;
    if (footerGrams)      footerGrams.textContent   = state.totalGrams;
    if (footerGramsFill)  footerGramsFill.style.width = gramPct + '%';

    // Summary items list
    renderSummaryItems();

    // Enable/disable plus buttons based ONLY on maxGrams limit
    var atLimit = state.totalGrams >= maxGrams;
    btnPlusList.forEach(function (btn) {
      var card   = btn.closest('.ccb-card');
      if (card.classList.contains('is-locked')) { btn.disabled = true; return; }
      var weight = parseInt(card.dataset.weight, 10) || 0;
      btn.disabled = atLimit || (state.totalGrams + weight) > maxGrams;
    });

    // Enable/disable minus buttons (never re-enable locked cards)
    btnMinusList.forEach(function (btn) {
      var card  = btn.closest('.ccb-card');
      if (card.classList.contains('is-locked')) { btn.disabled = true; return; }
      var input = btn.closest('.ccb-quantity').querySelector('.ccb-qty-input');
      btn.disabled = parseInt(input.value, 10) <= 0;
    });

    // Card badge
    cards.forEach(function (card) {
      var name  = card.dataset.name;
      var badgeQty = card.querySelector('.ccb-badge-qty');
      var sel   = state.selections[name];
      if (sel && sel.qty > 0) {
        card.classList.add('has-selection');
        if (badgeQty) badgeQty.textContent = sel.qty;
      } else {
        card.classList.remove('has-selection');
      }
    });

    // Show/hide sticky footer
    if (stickyFooter) {
      if (state.totalGrams > 0) {
        stickyFooter.classList.add('is-visible');
      } else {
        stickyFooter.classList.remove('is-visible');
      }
    }

    // Drawer progress — mirrors grams meter
    if (drawerPieces)    drawerPieces.textContent  = state.totalPieces;
    if (drawerGrams)     drawerGrams.textContent   = state.totalGrams;
    if (drawerPct)       drawerPct.textContent     = Math.round(gramPct) + '%';
    if (drawerGramsBar)  drawerGramsBar.style.width = gramPct + '%';

    // Drawer items list (mirrors panel)
    renderDrawerItems();

    // Calculate if any available chocolates can physically fit within remaining grams
    var canAddAnyMore = false;
    cards.forEach(function(c) {
      if (!c.classList.contains('is-locked')) {
        var w = parseInt(c.dataset.weight, 10);
        if (!isNaN(w) && w > 0 && (state.totalGrams + w) <= maxGrams) {
          canAddAnyMore = true;
        }
      }
    });

    var isStaleBlocked = (state.totalGrams > 0) && !canAddAnyMore;

    // Atelier: schematic tray + state-based phrase
    renderTray();
    var phrase = getProgressPhrase(isStaleBlocked);
    if (phraseEl)        phraseEl.textContent       = phrase;
    if (drawerPhraseEl)  drawerPhraseEl.textContent = phrase;

    // CTA enable - Validation: grams >= maxGrams OR isStaleBlocked
    var isValid = (state.totalGrams > 0) && (state.totalGrams >= maxGrams || isStaleBlocked);
    
    if (addToCartBtn)  addToCartBtn.disabled  = !isValid;
    if (summaryCta)    summaryCta.disabled    = !isValid;
    if (drawerCta)     drawerCta.disabled     = !isValid;
  }

  function renderSummaryItems() {
    if (!summaryItems) return;
    var keys = Object.keys(state.selections).filter(function (k) {
      return state.selections[k].qty > 0;
    });

    if (keys.length === 0) {
      summaryItems.innerHTML = '<li class="ccb-summary__empty" id="ccb-summary-empty">No pieces selected yet</li>';
      return;
    }

    var html = '';
    keys.forEach(function (name) {
      var qty = state.selections[name].qty;
      html += '<li class="ccb-summary__item">'
            +   '<span class="ccb-summary__item-name">' + name + '</span>'
            +   '<span class="ccb-summary__item-qty">×' + qty + '</span>'
            +   '<button type="button" class="ccb-summary__item-remove" data-name="' + name.replace(/"/g, '&quot;') + '" aria-label="Remove">×</button>'
            + '</li>';
    });
    summaryItems.innerHTML = html;

    // Bind remove buttons
    summaryItems.querySelectorAll('.ccb-summary__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.name;
        if (state.selections[name]) {
          // Find matching card and reset its input
          cards.forEach(function (card) {
            if (card.dataset.name === name) {
              var input = card.querySelector('.ccb-qty-input');
              if (input) input.value = 0;
            }
          });
          delete state.selections[name];
          removeAllFills(name);
          updateUI();
        }
      });
    });
  }

  // ── Tray (schematic box visualization) ───────────────────────────────────
  // One slot per UNIQUE chocolate, in the order it was first added. Quantity
  // shown as a small italic gold "×N" badge when > 1. New slots play a
  // one-shot fill animation; quantity updates are silent.
  function getUniqueFills() {
    var seen = {};
    var unique = [];
    for (var i = 0; i < state.fillOrder.length; i++) {
      var f = state.fillOrder[i];
      if (!seen[f.name]) {
        seen[f.name] = true;
        unique.push(f);
      }
    }
    return unique;
  }

  function buildSlotInnerHtml(name, image, qty) {
    var safeName = (name || '').replace(/"/g, '&quot;');
    var counter = qty > 1 ? '<span class="ccb-tray__count">×' + qty + '</span>' : '';
    var removeBtn =
      '<button type="button" class="ccb-tray__remove" aria-label="Remove one ' + safeName + '" tabindex="0">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<line x1="7" y1="7" x2="17" y2="17"/>' +
          '<line x1="17" y1="7" x2="7" y2="17"/>' +
        '</svg>' +
      '</button>';
    return (
      '<div class="ccb-image-frame ccb-image-frame--slot">' +
        '<img src="' + image + '" alt="' + safeName + '" loading="lazy">' +
      '</div>' +
      removeBtn +
      counter
    );
  }

  function applyTrayFills(slots, unique) {
    if (!slots || slots.length === 0) return;
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var fill = unique[i];
      if (fill) {
        var qty = state.selections[fill.name] ? state.selections[fill.name].qty : 0;
        var currentName = slot.dataset.fillName || '';

        if (currentName !== fill.name) {
          // New chocolate landing in this slot — full render + fill animation
          slot.classList.add('is-filled');
          slot.dataset.fillName = fill.name;
          slot.dataset.fillQty = String(qty);
          slot.innerHTML = buildSlotInnerHtml(fill.name, fill.image, qty);
        } else if (slot.dataset.fillQty !== String(qty)) {
          // Same chocolate, qty changed — update counter only (no re-animation,
          // and the X button stays untouched so its click handler still works)
          slot.dataset.fillQty = String(qty);
          var badge = slot.querySelector('.ccb-tray__count');
          if (qty > 1) {
            if (badge) {
              badge.textContent = '×' + qty;
            } else {
              slot.insertAdjacentHTML('beforeend', '<span class="ccb-tray__count">×' + qty + '</span>');
            }
          } else if (badge) {
            badge.remove();
          }
        }
      } else if (slot.classList.contains('is-filled')) {
        slot.classList.remove('is-filled');
        slot.removeAttribute('data-fill-name');
        slot.removeAttribute('data-fill-qty');
        slot.innerHTML = '';
      }
    }
  }

  function renderTray() {
    var unique = getUniqueFills();
    applyTrayFills(traySlots, unique);
    applyTrayFills(drawerTraySlots, unique);
  }

  // Event delegation: clicking the X on any tray slot decrements that chocolate
  // by 1 (consistent with the on-card minus button). Works for both the desktop
  // panel tray and the mobile drawer tray.
  function handleTrayRemoveClick(e) {
    var btn = e.target.closest && e.target.closest('.ccb-tray__remove');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var slot = btn.closest('.ccb-tray__slot');
    if (!slot) return;
    var name = slot.dataset.fillName;
    if (!name) return;
    // Find the matching product card so the existing quantity logic runs
    // (it updates input, state, fillOrder, tray, summary, CTA — everything)
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.name === name) {
        handleQuantityChange(cards[i], 'minus');
        break;
      }
    }
  }
  if (trayEl) trayEl.addEventListener('click', handleTrayRemoveClick);
  if (drawerTrayEl) drawerTrayEl.addEventListener('click', handleTrayRemoveClick);

  // ── Progress phrase ──────────────────────────────────────────────────────
  function getProgressPhrase(isStaleBlocked) {
    var isValid = (state.totalGrams > 0) && (state.totalGrams >= maxGrams || isStaleBlocked);
    
    if (isValid) return 'Your signature composition is ready';
    if (state.totalGrams === 0) return 'Begin your composition';
    
    var remainingGrams = maxGrams - state.totalGrams;
    return remainingGrams + 'g remaining to complete';
  }

  // ── fillOrder mutations ──────────────────────────────────────────────────
  function pushFill(name, weight, image) {
    state.fillOrder.push({ name: name, weight: weight, image: image });
  }

  function popLastFill(name) {
    for (var i = state.fillOrder.length - 1; i >= 0; i--) {
      if (state.fillOrder[i].name === name) {
        state.fillOrder.splice(i, 1);
        return;
      }
    }
  }

  function removeAllFills(name) {
    state.fillOrder = state.fillOrder.filter(function (f) { return f.name !== name; });
  }

  function renderDrawerItems() {
    if (!drawerItems) return;
    var keys = Object.keys(state.selections).filter(function (k) {
      return state.selections[k].qty > 0;
    });

    if (keys.length === 0) {
      drawerItems.innerHTML = '<li class="ccb-summary__empty">No pieces selected yet</li>';
      return;
    }

    var html = '';
    keys.forEach(function (name) {
      var qty = state.selections[name].qty;
      html += '<li class="ccb-summary__item">'
            +   '<span class="ccb-summary__item-name">' + name + '</span>'
            +   '<span class="ccb-summary__item-qty">×' + qty + '</span>'
            +   '<button type="button" class="ccb-summary__item-remove" data-name="' + name.replace(/"/g, '&quot;') + '" aria-label="Remove ' + name.replace(/"/g, '') + '">×</button>'
            + '</li>';
    });
    drawerItems.innerHTML = html;

    drawerItems.querySelectorAll('.ccb-summary__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.name;
        if (state.selections[name]) {
          cards.forEach(function (card) {
            if (card.dataset.name === name) {
              var input = card.querySelector('.ccb-qty-input');
              if (input) input.value = 0;
            }
          });
          delete state.selections[name];
          removeAllFills(name);
          updateUI();
        }
      });
    });
  }

  // ── Drawer ───────────────────────────────────────────────────────────────
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (footerExpandBtn) footerExpandBtn.classList.add('is-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (footerExpandBtn) footerExpandBtn.classList.remove('is-open');
  }

  if (footerExpandBtn) footerExpandBtn.addEventListener('click', function () {
    if (drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
  if (drawerClose)    drawerClose.addEventListener('click', closeDrawer);

  if (drawerCta) drawerCta.addEventListener('click', function (e) {
    e.preventDefault();
    closeDrawer();
    submitCart();
  });

  // ── Quantity change ──────────────────────────────────────────────────────
  function handleQuantityChange(card, action) {
    if (card.classList.contains('is-locked')) return;
    var name   = card.dataset.name;
    var weight = parseInt(card.dataset.weight, 10) || 0;
    var image  = card.dataset.image || '';
    var input  = card.querySelector('.ccb-qty-input');
    var qty    = parseInt(input.value, 10) || 0;

    if (action === 'plus') {
      if (state.totalGrams >= maxGrams || (state.totalGrams + weight) > maxGrams) {
        if (isClassic) showUpgradeModal();
        return;
      }
      qty++;
      pushFill(name, weight, image);
    } else {
      if (qty > 0) {
        qty--;
        popLastFill(name);
      }
    }

    input.value = qty;

    if (qty > 0) {
      state.selections[name] = { qty: qty, weight: weight };
    } else {
      delete state.selections[name];
    }

    updateUI();
  }

  btnPlusList.forEach(function (btn) {
    btn.addEventListener('click', function () {
      handleQuantityChange(btn.closest('.ccb-card'), 'plus');
    });
  });

  btnMinusList.forEach(function (btn) {
    btn.addEventListener('click', function () {
      handleQuantityChange(btn.closest('.ccb-card'), 'minus');
    });
  });

  qtyInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var name = input.closest('.ccb-card').dataset.name;
      input.value = (state.selections[name] ? state.selections[name].qty : 0);
    });
  });

  // ── Modal ─────────────────────────────────────────────────────────────────
  function showUpgradeModal() {
    if (upgradeModal) upgradeModal.classList.add('is-active');
  }

  function hideUpgradeModal() {
    if (upgradeModal) upgradeModal.classList.remove('is-active');
  }

  closeModalBtns.forEach(function (btn) {
    btn.addEventListener('click', hideUpgradeModal);
  });

  // ── Cart submission ───────────────────────────────────────────────────────
  function submitCart() {
    if (!baseVariantId) {
      alert('Base product not configured. Please set it in theme settings.');
      return;
    }

    var properties = {
      'Total Pieces': state.totalPieces,
      'Total Grams': state.totalGrams
    };

    for (var name in state.selections) {
      properties[name] = state.selections[name].qty;
    }

    var formData = {
      items: [{ id: parseInt(baseVariantId, 10), quantity: 1, properties: properties }]
    };

    setCtaState('loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart_add_failed');
      return r.json();
    })
    .then(function () {
      setCtaState('success');
      return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble').catch(function () { return null; });
    })
    .then(function (r) { return r ? r.json() : null; })
    .then(function (sections) {
      // Update cart bubble count in the header regardless of drawer availability
      if (sections && sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newContent = doc.querySelector('.shopify-section');
          if (newContent) bubble.innerHTML = newContent.innerHTML;
        }
      }

      var cartDrawerEl = document.querySelector('cart-drawer');
      var canRenderDrawer = sections && sections['cart-drawer'] && cartDrawerEl && typeof cartDrawerEl.renderContents === 'function';

      // Brief delay so the success state is visible before drawer slides in
      setTimeout(function () {
        if (canRenderDrawer) {
          cartDrawerEl.renderContents({ sections: sections });
          setTimeout(function () { setCtaState('idle'); }, 1400);
        } else {
          // No drawer available — navigate to /cart (has upsell + checkout)
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      }, 700);
    })
    .catch(function () {
      setCtaState('idle');
      alert('There was an error adding your box to the cart. Please try again.');
    });
  }

  function setCtaState(s) {
    [addToCartBtn, summaryCta, drawerCta].forEach(function (btn) {
      if (!btn) return;
      btn.classList.remove('is-loading', 'is-success');
      if (s === 'loading') btn.classList.add('is-loading');
      if (s === 'success') btn.classList.add('is-success');
    });
  }

  if (addToCartBtn) addToCartBtn.addEventListener('click', function (e) { e.preventDefault(); submitCart(); });
  if (summaryCta)   summaryCta.addEventListener('click',   function (e) { e.preventDefault(); submitCart(); });

  // ── Filters ───────────────────────────────────────────────────────────────
  var activeCategory = 'all';
  var activeType = 'all';
  var activeSort = 'default';

  var categoryBtns = document.querySelectorAll('[data-filter-group="category"] .ccb-filter-btn');
  var typeBtns = document.querySelectorAll('[data-filter-group="type"] .ccb-filter-btn');
  var sortBtns = document.querySelectorAll('[data-filter-group="sort"] .ccb-filter-btn');

  if (categoryBtns.length > 0) {
    categoryBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        categoryBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        activeCategory = btn.dataset.filter;
        initPagination();
      });
    });
  }

  if (typeBtns.length > 0) {
    typeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        typeBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        activeType = btn.dataset.filter;
        initPagination();
      });
    });
  }

  if (sortBtns.length > 0) {
    sortBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sortBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        activeSort = btn.dataset.filter;
        initPagination();
      });
    });
  }


  // ── Pagination ────────────────────────────────────────────────────────────
  function getItemsPerPage() {
    return window.innerWidth >= 990 ? 12 : (window.innerWidth >= 750 ? 9 : 8);
  }
  var ITEMS_PER_PAGE = getItemsPerPage();
  var currentPage    = 0;
  var visibleCards   = [];
  var totalPages     = 0;
  var prevBtn        = document.getElementById('ccb-page-prev');
  var nextBtn        = document.getElementById('ccb-page-next');
  
  if (prevBtn) prevBtn.addEventListener('click', function () {
    if (currentPage > 0) { showPage(currentPage - 1); scrollToBuilder(); }
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (currentPage < totalPages - 1) { showPage(currentPage + 1); scrollToBuilder(); }
  });

  function showPage(page) {
    currentPage = page;
    var start = page * ITEMS_PER_PAGE;
    var end   = start + ITEMS_PER_PAGE;
    visibleCards.forEach(function (card, i) {
      card.style.display = (i >= start && i < end) ? '' : 'none';
    });
    var currentEl = document.getElementById('ccb-page-current');
    if (currentEl) currentEl.textContent = page + 1;
    if (prevBtn) prevBtn.disabled  = page === 0;
    if (nextBtn) nextBtn.disabled  = page >= totalPages - 1;
  }

  function initPagination() {
    ITEMS_PER_PAGE = getItemsPerPage();
    var allCards  = Array.from(document.querySelectorAll('#ccb-grid .ccb-card'));
    var pagination = document.getElementById('ccb-pagination');
    var totalEl   = document.getElementById('ccb-page-total');
    
    // Sort cards according to activeSort state
    allCards.sort(function(a, b) {
      var weightA = parseInt(a.dataset.weight, 10) || 0;
      var weightB = parseInt(b.dataset.weight, 10) || 0;
      var nameA = (a.dataset.name || '').toLowerCase();
      var nameB = (b.dataset.name || '').toLowerCase();

      if (activeSort === 'asc') {
        if (weightA !== weightB) return weightA - weightB;
        return nameA.localeCompare(nameB);
      } else if (activeSort === 'desc') {
        if (weightA !== weightB) return weightB - weightA;
        return nameA.localeCompare(nameB);
      }
      return nameA.localeCompare(nameB);
    });
    
    // Re-append sorted cards to the grid so DOM order matches
    var grid = document.getElementById('ccb-grid');
    if (grid) {
      allCards.forEach(function(card) {
        grid.appendChild(card);
      });
    }

    visibleCards = allCards.filter(function(card) {
      var cat = card.dataset.category || '';
      var type = card.dataset.type || '';
      
      var matchesCategory = (activeCategory === 'all') || cat.includes(activeCategory);
      var matchesType = (activeType === 'all') || (type === activeType);
      
      return matchesCategory && matchesType;
    });

    allCards.forEach(function(card) {
      if (!visibleCards.includes(card)) card.style.display = 'none';
    });

    totalPages = Math.ceil(visibleCards.length / ITEMS_PER_PAGE);

    if (totalPages <= 1) {
      if (pagination) pagination.setAttribute('hidden', '');
    } else {
      if (pagination) pagination.removeAttribute('hidden');
    }

    if (totalEl) totalEl.textContent = totalPages || 1;

    showPage(0);
  }

  function scrollToBuilder() {
    var builder = document.getElementById('ccb-builder');
    if (builder) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Smart Atelier Actions: Auto-Fill Remaining Box & Clear All
  function handleAutoFill() {
    var availableCards = Array.from(document.querySelectorAll('.ccb-card:not(.is-locked)'));
    if (availableCards.length === 0) return;

    var safetyMax = 200;
    var counter = 0;

    while (state.totalGrams < maxGrams && counter < safetyMax) {
      counter++;
      var remainingGrams = maxGrams - state.totalGrams;

      var fittingCards = availableCards.filter(function(card) {
        var w = parseInt(card.dataset.weight, 10) || 0;
        return w > 0 && w <= remainingGrams;
      });

      if (fittingCards.length === 0) break;

      var randomCard = fittingCards[Math.floor(Math.random() * fittingCards.length)];
      var weight = parseInt(randomCard.dataset.weight, 10) || 0;
      var name = randomCard.dataset.name;
      var image = randomCard.dataset.image || '';
      var input = randomCard.querySelector('.ccb-qty-input');

      var currentQty = state.selections[name] ? state.selections[name].qty : 0;
      var nextQty = currentQty + 1;

      if (input) input.value = nextQty;
      state.selections[name] = { qty: nextQty, weight: weight };
      state.fillOrder.push({ name: name, weight: weight, image: image });

      state.totalPieces++;
      state.totalGrams += weight;
    }
    updateUI();
  }

  function handleClearAll() {
    cards.forEach(function (card) {
      var input = card.querySelector('.ccb-qty-input');
      if (input) input.value = 0;
    });
    state.selections = {};
    state.fillOrder = [];
    updateUI();
  }

  var autoFillBtn = document.getElementById('ccb-auto-fill-btn');
  if (autoFillBtn) autoFillBtn.addEventListener('click', handleAutoFill);

  var drawerAutoFillBtn = document.getElementById('ccb-drawer-auto-fill-btn');
  if (drawerAutoFillBtn) drawerAutoFillBtn.addEventListener('click', handleAutoFill);

  var clearAllBtn = document.getElementById('ccb-clear-all-btn');
  if (clearAllBtn) clearAllBtn.addEventListener('click', handleClearAll);

  var drawerClearAllBtn = document.getElementById('ccb-drawer-clear-all-btn');
  if (drawerClearAllBtn) drawerClearAllBtn.addEventListener('click', handleClearAll);

  initPagination();
  updateUI();
  initStickyPanel();
  initReveals();
});

// ── Reveal observer (fade-up on scroll for [data-reveal] elements) ───────────
function initReveals() {
  var els = document.querySelectorAll('[data-reveal]');
  if (els.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.revealDelay, 10) || 0;
      if (delay > 0) {
        setTimeout(function () { el.classList.add('is-revealed'); }, delay);
      } else {
        el.classList.add('is-revealed');
      }
      observer.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { observer.observe(el); });
}

// ── Sticky panel (JS-driven, immune to overflow:hidden ancestors) ────────────
function initStickyPanel() {
  var panel   = document.getElementById('ccb-summary-panel');
  var gallery = document.querySelector('.ccb-gallery-col');
  if (!panel || !gallery) return;

  // Only on desktop
  if (window.innerWidth < 990) return;

  var MARGIN = 24; // gap from viewport top (or below sticky header)

  function headerOffset() {
    // Respect Shopify theme CSS variable if set
    var fromVar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    if (!isNaN(fromVar) && fromVar > 0) return fromVar + MARGIN;

    // Otherwise measure the first sticky/fixed element above the builder
    var candidates = document.querySelectorAll('header, [id*="header"], [class*="header"], sticky-header');
    for (var i = 0; i < candidates.length; i++) {
      var pos = getComputedStyle(candidates[i]).position;
      if (pos === 'sticky' || pos === 'fixed') {
        return candidates[i].offsetHeight + MARGIN;
      }
    }
    return MARGIN;
  }

  function tick() {
    if (window.innerWidth < 990) {
      panel.style.transform = '';
      panel.style.maxHeight  = '';
      return;
    }

    var topOff    = headerOffset();
    var gallRect  = gallery.getBoundingClientRect();
    var panelH    = panel.offsetHeight;
    var gallH     = gallery.offsetHeight;
    var maxShift  = Math.max(0, gallH - panelH);

    var shift;
    if (gallRect.top >= topOff) {
      shift = 0;                                    // not yet in sticky zone
    } else {
      shift = Math.min(topOff - gallRect.top, maxShift); // clamp to bottom
    }

    panel.style.transform = shift > 0 ? 'translateY(' + shift + 'px)' : '';
    panel.style.maxHeight = 'calc(100vh - ' + (topOff + MARGIN) + 'px)';
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  tick();
}
